import React from "react";

const PurchaseListSkeleton: React.FC = () => {
  return (
    <div className="flex items-center justify-between relative max-md:p-4 max-sm:p-2 max-md:border max-md:border-[#89D9EE] max-md:rounded-xl">
      <div className="grid grid-cols-[192px_1fr] max-lg:grid-cols-[100px_1fr] max-sm:grid-cols-[80px_1fr] items-center gap-4 w-full py-2">
        <div className="grid h-32 place-items-center relative z-10">
          <div className="skeleton size-full"></div>
        </div>
        <div className="md:pr-3">
          <div className="flex items-center gap-3 mb-1 max-sm:mb-1 max-sm:gap-1">
            <div className="skeleton w-10 h-7 !rounded-md"></div>
            <div className="skeleton w-20 h-7 !rounded-md"></div>
          </div>
          <div className="skeleton w-3/4 h-7 !rounded-md"></div>
          <div className="flex items-center justify-between">
            <div className="skeleton w-40 h-7 !rounded-md mt-3"></div>
            <div className="flex items-center justify-between gap-2">
              <button className="skeleton w-8 h-8 !rounded-md"></button>
              <button className="skeleton w-8 h-8 !rounded-md"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseListSkeleton;
